export const ADD_NEW_CARD_TEST_IDS = {
    CARD_NUMBER: "card_number",
    CARD_ICON: "card_icon",
    CVV: "card_cvv",
    EXPIRY: "card_expiry",
    CARD_HOLDER_NAME: "cardholder_name",
    CARD_HOLDER_NICKNAME: "cardholder_nickname",
    SAVE_DETAILS_CHECKBOX: "save_tick",
    SAVE_DETAILS_TEXT: "save_text",
    PROCEED_TO_PAYMENT_BUTTON: "proceed_btn",
    WE_ACCEPT_CARDS: "we_accept_cards",
    SELECTION_CARD_CHECKBOX: "selection-card-tick",
    SELECTION_CARD_TEXT: "selection-card-text",
    SELECTION_CARD_SUB_TEXT: "selection-card-sub-text",

    OFFER_BANNER: "offer_banner",
    SAVE_CARD_CTA_HELPER: "save_card_cta_helper",
};
